import Image from '../../Image';
import Link from '../../Link';

// assets
import UserTop from '../images/user-top.svg';
import LogoSlogan from '../images/logo-slogan.svg';
import { useAuth } from '../../../context/auth-context';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';

export default function NavbarInside(): JSX.Element {
    const auth = useAuth();
    const isAuthenticated = auth.isLoggedIn;
    const router = useHistory();

    const handleLogout = async (e) => {
        e.preventDefault();
        await auth.logout();
        router.goBack;
    };

    useEffect(() => {
        console.log({ auth });
    }, [auth]);

    return (
        <div className="flex-none md:flex relative z-10 pt-2 md:pt-8  pb-0 md:pb-8 w-full text-center items-center justify-center">
            <nav className="flex w-full sm:w-10/12 px-2 md:px-10  ">
                <div className="w-full md:w-1/2 text-center justify-center">
                    <Link to="/">
                        <div className="block w-auto cursor-pointer ">
                            <Image
                                imgClassName="h-16"
                                height={62}
                                src={LogoSlogan}
                                alt="SuperMatch - Juega donde y cuando quieras"
                            />
                        </div>
                    </Link>
                </div>
                <div className="flex items-center justify-center md:justify-end w-1/2 text-center pl-0 md:text-right">
                    <div className="flex justify-center md:justify-end content-center items-end text-xs md:text-xl pr-0 md:pr-5 text-white font-bold">
                        {!isAuthenticated ? (
                            <Link to={'/login'}>Iniciar sesión</Link>
                        ) : (
                            <div className="cursor-pointer" onClick={handleLogout}>
                                Salir
                            </div>
                        )}
                    </div>
                    <div className="hidden md:block">
                        <Link to={`${isAuthenticated ? '/perfil' : '/login'}`}>
                            {' '}
                            <Image
                                src={
                                    auth && auth.user && auth.user.photoURL && auth.user.photoURL !== '#'
                                        ? auth.user.photoURL
                                        : UserTop
                                }
                                alt="Perfil"
                                imgClassName={`rounded-full  w-14 h-14 ${
                                    auth && auth.user && auth.user.photoURL && auth.user.photoURL !== '#'
                                        ? 'border-2 border-white'
                                        : ''
                                }`}
                            />
                        </Link>
                    </div>
                </div>
            </nav>
        </div>
    );
}
